// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_lg-0";